function LikeIcon({ className }) {
  return (
    <div className={className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          d='M15.8823 7.2061C15.5478 6.7411 14.8495 6.18762 13.4283 6.18762H11.0613V4.32237C11.0613 3.38037 10.5932 2.50587 9.80948 1.98237C9.36173 1.68387 8.81127 1.60735 8.29977 1.77235C7.78677 1.93735 7.38472 2.3206 7.18896 2.84635L5.59302 7.68762H3.37598C2.44598 7.68762 1.68848 8.44437 1.68848 9.37512V14.6251C1.68848 15.5559 2.44598 16.3126 3.37598 16.3126H11.929C13.801 16.3126 14.2593 15.4028 14.5975 14.3896L16.0968 9.8896C16.447 8.8366 16.3705 7.88335 15.8823 7.2061ZM2.81274 14.6251V9.37512C2.81274 9.06462 3.06549 8.81262 3.37524 8.81262H4.87524V15.1876H3.37524C3.06549 15.1876 2.81274 14.9356 2.81274 14.6251ZM15.028 9.53337L13.5287 14.0334C13.2625 14.8336 13.0953 15.1876 11.9283 15.1876H6.00024V8.81262C6.24324 8.81262 6.45779 8.65661 6.53354 8.42636L8.24878 3.22062C8.31703 3.03987 8.46026 2.90263 8.64401 2.84338C8.82776 2.78338 9.02422 2.81186 9.18472 2.91836C9.65497 3.23186 9.93546 3.75687 9.93546 4.32237V6.75012C9.93546 7.06062 10.1875 7.31262 10.498 7.31262H13.4275C13.9495 7.31262 14.641 7.40786 14.9695 7.86386C15.2365 8.23436 15.259 8.84337 15.028 9.53337Z'
          fill='#20C997'
        />
      </svg>
    </div>
  );
}

export default LikeIcon;
